import type { CardHeaderProps as ChakraCardHeaderProps } from '@chakra-ui/react';
import { CardHeader as ChakraCardHeader } from '@chakra-ui/react';
import React from 'react';

import type { OmitChakraProps } from '../../utils/typeUtils';
import { withChakraAs } from '../../utils/withChakraAs';

export type CardHeaderProps = OmitChakraProps<ChakraCardHeaderProps>;

export const CardHeader = withChakraAs<CardHeaderProps, 'div'>(
  ({ children, ...props }) => {
    return <ChakraCardHeader {...props}>{children}</ChakraCardHeader>;
  },
);
